module.exports = {
  //↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓开发配置↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  // baseUrl: "http://localhost:7000",
  // fileUrl: "https://admin.yufeitong.com/minio/yufeitong",
  // uploadUrl: "http://localhost:7000",

  //↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓测试服配置↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  // baseUrl: "https://yft2.tdss.com.cn:7099/admin",
  // fileUrl: "https://yft2.tdss.com.cn:7099/uav-minio/yufeitong",
  // uploadUrl: "https://yft2.tdss.com.cn:7099/uav",
  // apiUrl: 'https://yft2.tdss.com.cn:7099/api',

  //↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓正式服配置↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  baseUrl: "https://admin.yufeitong.com",
  fileUrl: "https://admin.yufeitong.com/minio/yufeitong",
  uploadUrl: "https://admin.yufeitong.com",
}



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = D08P
// module chunks = 26